import { render } from "./TheTheThaoSuNghiep.vue?vue&type=template&id=c0c886fa"
import script from "./TheTheThaoSuNghiep.vue?vue&type=script&lang=js"
export * from "./TheTheThaoSuNghiep.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__